import { Component, Injector, ViewEncapsulation, OnInit, ViewChild, Input, Renderer2, Output, EventEmitter } from '@angular/core';
import { NgForm } from '@angular/forms';
import { MatDialog, MatDialogRef } from '@angular/material';
import { GridComponent, GridDataResult, PageChangeEvent } from '@progress/kendo-angular-grid';
import { ToastrService } from 'ngx-toastr';
import * as _ from 'lodash';
import { CommonService } from 'src/app-core/services/common.service';
import { ServicesApiService } from 'src/app/services/services-api.service';
import { CommonDataModel } from '../common-data-model';
const hasClass = (el, className) => new RegExp(className).test(el.className);
const isChildOf = (el, className) => {
  while (el && el.parentElement) {
    if (hasClass(el.parentElement, className)) {
      return true;
    }
    el = el.parentElement;
  }
  return false;
};
@Component({
  selector: 'app-services-list',
  templateUrl: './services-list.component.html',
  styleUrls: ['./services-list.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class ServicesListComponent implements OnInit {
  @ViewChild('grid', { static: true }) private grid: GridComponent;
  @ViewChild('accountServiceForm', { static: true }) accountServiceForm: NgForm;
  @Output() emitServices: EventEmitter<any> = new EventEmitter<any>();
  @Input() accountId: any;
  commmonDataModel = new CommonDataModel();
  editedRowIndex: number;
  serviceTypes: any;
  serviceTypesCopy: any;
  categories: any;
  revenueCategories: any;
  gridItems: any = {
    data: [],
    total: 0
  };
  constructor(private servicesApiService: ServicesApiService,
              private commonService: CommonService,
              private toastr: ToastrService,
              private dialog: MatDialog,
              private renderer: Renderer2) {
    this.renderer.listen(
      'document',
      'click',
      ({ target }) => {
        if (!isChildOf(target, 'accountServiceGrid')) {
          if (this.accountServiceForm.valid) {
            this.grid.closeRow(this.editedRowIndex);
            this.editedRowIndex = null;
          }
        }
      });
  }

  ngOnInit() {
    this.getCategories();
    this.getRevenueCategories();
    this.getServiceType();
    this.getServices();
  }

  getServices(): void {
    this.commonService.getAccountServices(`AccountId=${this.accountId}`).subscribe(response => {
      this.gridItems.data = response.data;
      this.gridItems.total = response.data.length;
      this.gridItems.data.forEach((item, index) => this.mappingServiceDropDownData(item.revenueCategoryId, index));
      this.emitServices.emit();
    });
  }

  getCategories(): void {
    this.servicesApiService.getCategories().subscribe(response => {
      if (response.isSuccess) {
        this.categories = response.data;
      }
    });
  }

  getRevenueCategories(): void {
    this.servicesApiService.getRevenueCategories().subscribe(response => {
      if (response.isSuccess) {
        this.revenueCategories = response.data;
      }
    });
  }

  onAddNewService(): void {
    this.gridItems.data.splice(0, 0, this.generateNewRow());
    this.mappingServiceDropDownData(null, 0);
    this.accountServiceForm.form.markAsDirty();
  }

  onCellClickHandler({ sender, rowIndex, columnIndex, dataItem, isEdited }, grid: any) {
    grid.closeRow(this.editedRowIndex);
    this.editedRowIndex = rowIndex;
    sender.editRow(rowIndex);
  }

  onRevenueCategoryOpen(index: number) {
    if (index !== this.editedRowIndex) {
      if (this.accountServiceForm.valid) {
        this.grid.closeRow(this.editedRowIndex);
        this.editedRowIndex = index;
        this.grid.editRow(index);
      }
    }
  }



  onRevenueCategoryChange(event: any, dataItem: any, index: number) {
    this.commonService.objectMapping(dataItem, this.generateNewRow());
    this.getServiceType();

    this.mappingServiceDropDownData(event.revenueCategoryId, index);

  }

  getServiceType(): void {
    this.servicesApiService.getServiceLookup().subscribe(response => {
      this.serviceTypes = response.data;
      this.serviceTypesCopy = response.data;
      this.gridItems.data.forEach((item, index) => {
          this.mappingServiceDropDownData(
              item.revenueCategoryId,
              index,
          );
      });

    });
  }

  onServiceChange(event: any, dataItem: any, index: number) {
    this.mappingServiceDropDownData(event.revenueCategoryId, index);
    dataItem.revenueCategoryId = event.revenueCategoryId;
    this.servicesApiService.getCalculatedCost(event.serviceId).subscribe(response => {
      this.commonService.objectMapping(dataItem, response.data);
    });
  }

  onServiceDelete(rowIndex: number, accountServiceId: any) {
    if (accountServiceId) {
      this.commonService.deleteService({ accountServiceId: [accountServiceId] }).subscribe(response => {
        this.toastr.success('Services deleted Successfully');
        this.editedRowIndex = null;
        this.getServices();
       });
    } else {
      this.editedRowIndex = null;
      this.gridItems.data.splice(rowIndex, 1);
    }
  }

  onUpdateService() {
    if (this.validateService()) {
      if (this.gridItems.data && this.gridItems.data.length > 0) {
        const existingServices = this.gridItems.data.filter(item => item.id);
        const newServices = this.gridItems.data.filter(item => !item.id);
        newServices.map((item) => {item.accountId = this.accountId; return item; });
        if (newServices && newServices.length > 0) {
          existingServices.push.apply(existingServices, newServices);
        }
        const servicesRequest = this.gridItems.data.map((item) => {item.accountId = this.accountId; return item; });
        this.commonService.updateAccountServices({accountServices: existingServices}).subscribe(response => {
            this.getServices();
            this.toastr.success('Services updated Successfully');
        });
      }
    }
  }

  onMarkupPercentageChange(dataItem: any, event: any) {
    dataItem.markupPercentage = event ? (+event) : 0;
    this.calculateMarginPercentage(dataItem);
  }

  calculateMarginPercentage(dataItem: any) {
    const cost = 1;
    const markupPercentage = dataItem.markupPercentage ? (+dataItem.markupPercentage) : 0;
    if (cost > 0) {
      const marginPerValue = ((cost + (cost * markupPercentage / 100) - cost) / (cost + (cost * markupPercentage / 100))) * 100;
      dataItem.marginPercentage = marginPerValue.toFixed(2);
    }
  }

  onMarginPercentageChange(dataItem: any, event: any) {
    dataItem.marginPercentage = event ? (+event) : 0;
    this.calculateMarkupPercentage(dataItem);
  }

  calculateMarkupPercentage(dataItem: any) {
    const value = Math.abs(100 - dataItem.marginPercentage);
    const markupPercentage = Math.round(((100 / value) * 100 - 100));
    dataItem.markupPercentage = markupPercentage.toFixed(2);
  }

  mappingServiceDropDownData(revenueCategoryId: any, index: number) {
    if (this.serviceTypesCopy) {
      if (revenueCategoryId != null) {
        this.gridItems.data[index].serviceTypeDataSource =
          _.filter(this.serviceTypesCopy, [
            "revenueCategoryId",
            revenueCategoryId,
          ]);
          return;
      } else {
        return (this.gridItems.data[index].serviceTypeDataSource =
        this.serviceTypesCopy);
      }
    }
  }

  handleFilter(value: any, dataItem: any) {
    const results = dataItem.revenueCategoryId == null
        ? this.serviceTypes
        : _.filter(this.serviceTypes, ['revenueCategoryId', dataItem.revenueCategoryId]);

    return dataItem.serviceTypeDataSource = results.filter((s) => s.serviceName.trim().toLowerCase().indexOf(value.toLowerCase()) !== -1 || (s.revenueCategoryName && s.revenueCategoryName.trim().toLowerCase().indexOf(value.toLowerCase()) !== -1));
  }

  validateService(): boolean {
  const invalidService =  this.gridItems.data.find(item => !item.serviceId);
  if (invalidService) {
    this.toastr.warning('Please select service');
    return false;
  }
  return true;
  }

  generateNewRow(): any {
    return Object.assign({}, this.commmonDataModel.accountService);
  }
}
